import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { InformativePage } from 'src/app/models/informative-page';

export const getInformativePages = createAction(
  '[Informative Page] Get Informative Pages',
  props<{ studyId: number }>()
);

export const getInformativePagesSuccess = createAction(
  '[Informative Page] Get Informative Pages Success',
  props<{ informativePages: InformativePage[] }>()
);

export const getInformativePagesError = createAction(
  '[Informative Page] Get Informative Pages Error',
  props<{ err: HttpErrorResponse }>()
);

export const selectInformativePage = createAction(
  '[Informative Page] Select Informative Page',
  props<{ informativePageId: number }>()
);

export const selectInformativePageSuccess = createAction(
  '[Informative Page] Select Informative Page Success',
  props<{ selectedInformativePage: InformativePage }>()
);

export const selectInformativePageError = createAction(
  '[Informative Page] Select Informative Page Error',
  props<{ err: HttpErrorResponse }>()
);

export const setSelectedInformativePage = createAction(
  '[Informative Page] Set Selected Informative Page',
  props<{ selectedInformativePage: InformativePage }>()
);

export const createInformativePage = createAction(
  '[Informative Page] Create Informative Page',
  props<{ informativePage: InformativePage }>()
);

export const createInformativePageSuccess = createAction(
  '[Informative Page] Create Informative Page Success',
  props<{ newInformativePage: InformativePage }>()
);

export const createInformativePageError = createAction(
  '[Informative Page] Create Informative Page Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateInformativePage = createAction(
  '[Informative Page] Update Informative Page',
  props<{ informativePage: InformativePage }>()
);

export const updateInformativePageSuccess = createAction(
  '[Informative Page] Update Informative Page Success',
  props<{ updatedInformativePage: InformativePage }>()
);

export const updateInformativePageError = createAction(
  '[Informative Page] Update Informative Page Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteInformativePage = createAction(
  '[Informative Page] Delete Informative Page',
  props<{ informativePage: InformativePage }>()
);

export const deleteInformativePageSuccess = createAction(
  '[Informative Page] Delete Informative Page Success',
  props<{ deletedInformativePage: InformativePage }>()
);

export const deleteInformativePageError = createAction(
  '[Informative Page] Delete Informative Page Error',
  props<{ err: HttpErrorResponse }>()
);
